import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  ButtonBase,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import { connect } from "react-redux";
type Props = {
  tanggal: string;
  title: string;
  link: string;
  expertise: string;
};

const AccordionRads = ({ tanggal, title, link, expertise }: Props) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
      //   variant="outlined"
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box>
          <Typography component="span" sx={{ display: "block" }}>
            {tanggal}
          </Typography>
          <Typography
            component="span"
            sx={{ color: "text.secondary", alignSelf: "center" }}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            maxHeight: "200px",
            overflowY: "scroll",
          }}
        >
          <Table>
            <TableBody>
              <TableRow
                // key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <ButtonBase
                    sx={{
                      borderBottom: "2px solid #FF0000",
                      paddingBottom: "4px",
                    }}
                    onClick={() => {
                      window.open(link, "_blank");
                    }}
                  >
                    <TroubleshootIcon fontSize="small" />
                    <Typography variant="body2" marginLeft="2px">
                      Lihat hasil
                    </Typography>
                  </ButtonBase>
                </TableCell>
              </TableRow>
              <TableRow
                // key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant="body2" textAlign={"justify"}>{expertise}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
const mapStateToProps = (state: any) => {
  return {
    // stateHistoryLab: state.history.laboratorium,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    // actOpenHasilRad: (link: any) => dispatch(openHasilLab(link)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccordionRads);
